// extracted by mini-css-extract-plugin
export default {"header":"MegaMenu_header__TnFPn","link":"MegaMenu_link__6cHtc","subLink":"MegaMenu_subLink__1nDvm","dropdownFooter":"MegaMenu_dropdownFooter__sQ7PQ"};